import { getCompanyInfoAppOrganizationCompanyInfoGet } from '@/client/sdk.gen'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SettingsPageSkeleton } from '../settings/-components/skeleton'
import { DistributorRestrictionBanner } from './-components/distributor-restriction-banner'

export const Route = createFileRoute('/_authed/_user/organization')({
  component: CompanyInfoLayout,
  pendingComponent: SettingsPageSkeleton,
  errorComponent: ({ error }) => (
    <div>
      <h1>Failed to load company information</h1>
      <p>{error?.message || 'An unexpected error occurred'}</p>
    </div>
  ),
  beforeLoad: ({ context }) => ({
    getTitle: () => 'Organization',
    hasOrganization: !!context.auth.organizationId,
  }),
  loader: async ({ context }) => {
    // Skip API call if user has no organization
    if (!context.hasOrganization) {
      return {
        initialData: undefined,
        hasCompanyInfo: false,
        noOrganization: true,
      }
    }

    const { data } = await getCompanyInfoAppOrganizationCompanyInfoGet({
      throwOnError: true,
    })

    // Determine if company has basic info filled out
    const hasCompanyInfo = !!(
      data?.companyName
      || data?.companyDescription
      || data?.qualificationArguments
      || data?.qualificationLogic
    )

    return {
      initialData: data ?? undefined,
      hasCompanyInfo,
      noOrganization: false,
    }
  },
})

function CompanyInfoLayout() {
  const { noOrganization } = Route.useLoaderData()

  if (noOrganization) {
    return (
      <div className="space-y-6 pb-8 px-4 py-4 lg:px-6 md:py-6">
        <div className="text-center py-12">
          <h2 className="text-xl font-semibold mb-2">No Organization</h2>
          <p className="text-muted-foreground">
            You are not currently associated with an organization. Contact support if you believe this is an error.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6 pb-8 px-4 py-4 lg:px-6 md:py-6">
      <DistributorRestrictionBanner />
      <Outlet />
    </div>
  )
}
